export const mediumViewport =
  document.querySelector("#root").offsetWidth <= 1300;
